var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-wallet-component"},[_c('div',{staticClass:"my-balance"},[_c('span',[_vm._v("我的余额："+_vm._s(_vm.myWallet.balance || 0)+"元")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }